// extracted by mini-css-extract-plugin
export default {"modal__wrapper":"Modal_modal__wrapper__Ztr5Q","modal":"Modal_modal__iWZau"};